import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import { normalizeMethodInfo } from "./reflection-info";
export var ServiceType = /*#__PURE__*/_createClass(function ServiceType(typeName, methods, options) {
  var _this = this;

  _classCallCheck(this, ServiceType);

  this.typeName = typeName;
  this.methods = methods.map(function (i) {
    return normalizeMethodInfo(i, _this);
  });
  this.options = options !== null && options !== void 0 ? options : {};
});